export const GET_LOG_REQUEST = "GET_LOG_REQUEST";
export const GET_LOG_SUCCESS = "GET_LOG_SUCCESS";
export const GET_LOG_FAILURE = "GET_LOG_FAILURE";